import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import styled from '@emotion/styled';
import { Flex } from '@Calix-Commerce/design-system/layout';

const QuoteDescriptionStyled = styled.span<{ placeholder: string }>`
  width: fit-content;
  font-size: 14px;
  padding: 6px 50px 6px 0;
  color: #555;
  z-index: 30;

  &:empty:before {
    content: attr(placeholder);
    color: #555;
  }

  &:focus-visible {
    outline: none;
  }
`;

const IconWrapper = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

const QuoteDescription = ({ quoteDescription, onEdit, placeholder, readonly = false }) => {
  return (
    <Flex
      alignment="center"
      style={{ position: 'relative', display: 'flex', width: 'fit-content' }}
    >
      <QuoteDescriptionStyled
        id="quoteDescription-input"
        contentEditable={!readonly}
        suppressContentEditableWarning={true}
        onBlur={(e) => {
          const inputField = document.getElementById('quoteDescription-input');
          const { textContent } = e.currentTarget;

          if (!textContent?.trim()) {
            if (inputField) {
              inputField.innerHTML = '';
            }
            onEdit('');
            return;
          } else {
            onEdit(textContent);
          }
        }}
        placeholder={placeholder}
      >
        {quoteDescription}
      </QuoteDescriptionStyled>
      {!readonly ? (
        <IconWrapper>
          <EditOutlinedIcon htmlColor="#0b38db" />
        </IconWrapper>
      ) : null}
    </Flex>
  );
};

export { QuoteDescription };
